<!-- Общая подробная карточка записи с заголовком, действиями и содержимым. -->
<template>
  <article class="record-list-details" :class="{ 'record-list-details--embedded': embedded }">
    <header class="record-list-details__header">
      <div class="record-list-details__topbar">
        <div class="record-list-details__badges"><slot name="badges" /></div>
        <slot name="actions" />
      </div>
      <h2 v-if="title">{{ title }}</h2>
      <slot name="meta" />
      <p v-if="description">{{ description }}</p>
    </header>
    <slot />
  </article>
</template>
<script>
export default {
  name: "RecordListDetailsCard",
  props: {
    title: { type: String, default: "" },
    description: { type: String, default: "" }, embedded: { type: Boolean, default: false },
  },
};
</script>
<style scoped>
.record-list-details {
  /* Колонка деталей бывает узкой и на широком экране */
  container-type: inline-size;
  container-name: record-list-details;
  padding: 28px;
  display: flex;
  flex-direction: column;
  gap: 26px;
  background: white;
  border: 1px solid #e5e9ef;
  border-radius: 12px;
}
.record-list-details__header {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.record-list-details__topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.record-list-details__badges {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.record-list-details__badges > :deep(:not(.base-status-select)) {
  /* Мелкие метки оптически выше текста крупного статуса */
  position: relative;
  top: 1px;
}
.record-list-details__header h2 {
  overflow-wrap: anywhere;
  font-size: 23px;
  line-height: 1.35;
  letter-spacing: -0.4px;
}
.record-list-details p {
  line-height: 1.6;
  font-size: 14px;
  color: #64748b;
  white-space: pre-line;
  overflow-wrap: anywhere;
}
@container record-list-details (max-width: 680px) {
  .record-list-details__topbar {
    flex-direction: column;
    align-items: stretch;
  }
}
@media (max-width: 640px) {
  .record-list-details {
    padding: 20px;
  }
  .record-list-details__header h2 {
    font-size: 20px;
  }
}
.record-list-details--embedded {
  padding: 0;
  border: 0;
  border-radius: 0;
}
</style>
